import React, { useMemo } from 'react'
import { every, map } from 'lodash'
import PropTypes from 'prop-types'

import { STATUS_FLAG_FIELD } from '../../../common/constants'

import LocationStatusCheckbox from './location-status-checkbox'

const LocationTableCheckAllColumn = ({
  locations,
  isTaskCurationDone,
  isTaskQaDone,
  disabled,
}) => {
  const locationIds = useMemo(() => map(locations, 'id'), [locations])

  const statusFlagFieldName = useMemo(() => {
    if (!isTaskCurationDone) {
      return STATUS_FLAG_FIELD.IS_CURATION_DONE
    }

    if (!isTaskQaDone) {
      return STATUS_FLAG_FIELD.IS_QA_DONE
    }

    return STATUS_FLAG_FIELD.IS_QC_DONE
  }, [isTaskCurationDone, isTaskQaDone])

  const checkboxValue = useMemo(
    () => every(locations, location => location[statusFlagFieldName]),
    [locations, statusFlagFieldName],
  )
  const tooltipTitle = useMemo(() => {
    if (!isTaskCurationDone) {
      return 'Set locations curation done'
    }

    if (!isTaskQaDone) {
      return 'Set locations qa done'
    }

    return 'Set locations qc done'
  }, [isTaskCurationDone, isTaskQaDone])

  return (
    <LocationStatusCheckbox
      locationIds={locationIds}
      value={checkboxValue}
      tooltip={tooltipTitle}
      statusFlagFieldName={statusFlagFieldName}
      disabled={disabled}
    />
  )
}

LocationTableCheckAllColumn.propTypes = {
  locations: PropTypes.arrayOf(PropTypes.object).isRequired,
  isTaskCurationDone: PropTypes.bool.isRequired,
  isTaskQaDone: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
}

LocationTableCheckAllColumn.defaultProps = {
  disabled: false,
}

export default LocationTableCheckAllColumn
